var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/auth-login/components/captcha.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import { Map as ImmutableMap } from 'immutable';
import React, { useState, useEffect } from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import { fetchCaptcha } from 'soapbox/actions/auth';
import { Stack, Text, Input } from 'soapbox/components/ui';
import { useAppDispatch } from 'soapbox/hooks';

const noOp = () => {};

const messages = defineMessages({
  placeholder: {
    "id": "registration.captcha.placeholder",
    "defaultMessage": "Enter the pictured text"
  }
});

const CaptchaField = _ref => {
  let {
    name,
    value,
    onChange = noOp,
    onFetch = noOp,
    onFetchFail = noOp,
    onClick = noOp,
    refreshInterval = 5 * 60 * 1000,
    // 5 minutes, Pleroma default
    idempotencyKey
  } = _ref;
  const dispatch = useAppDispatch();
  const [captcha, setCaptcha] = useState(ImmutableMap());
  const [refresh, setRefresh] = useState(undefined);

  const getCaptcha = () => {
    dispatch(fetchCaptcha()).then(response => {
      const captcha = ImmutableMap(response.data);
      setCaptcha(captcha);
      onFetch(captcha);
    }).catch(error => {
      onFetchFail(error);
    });
  };

  const startRefresh = () => {
    if (refreshInterval) {
      const newRefresh = setInterval(getCaptcha, refreshInterval);
      setRefresh(newRefresh);
    }
  };

  const endRefresh = () => {
    if (refresh) {
      clearInterval(refresh);
    }
  };

  useEffect(() => {
    getCaptcha();
    endRefresh();
    startRefresh(); // Refresh periodically

    return () => {
      endRefresh();
    };
  }, [idempotencyKey]);

  switch (captcha.get('type')) {
    case 'native':
      return /*#__PURE__*/React.createElement("div", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(Text, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 80,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "registration.captcha.hint",
        defaultMessage: "Click the image to get a new captcha",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81,
          columnNumber: 13
        }
      })), /*#__PURE__*/React.createElement(NativeCaptchaField, {
        captcha: captcha,
        onChange: onChange,
        onClick: onClick,
        name: name,
        value: value,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84,
          columnNumber: 11
        }
      }));

    case 'none':
    default:
      return null;
  }
};

const NativeCaptchaField = _ref2 => {
  let {
    captcha,
    onChange,
    onClick,
    name,
    value
  } = _ref2;
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center bg-white w-full border border-solid border-gray-300 dark:border-gray-600 rounded-md",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "captcha",
    src: captcha.get('url'),
    onClick: onClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    placeholder: intl.formatMessage(messages.placeholder),
    name: name,
    value: value,
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    onChange: onChange,
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 7
    }
  }));
};

export { CaptchaField as default, NativeCaptchaField };